import { Organization } from "../organization/organization.model";
import { CrudAbstractModel } from "../crud-abstract/crud-abstract.model";

export class Company extends CrudAbstractModel {
  constructor(
    public id: number,
    public name: string,
    public ref?: string,
    public organization?: Organization,
  ) {
    super(id);
  }

  public getId(): number {
    return this.id;
  }

  public get visibleOrganizationName(): string {
    return this.organization.getName();
  }

  public getRequestParams() {
    return {
      name: this.name,
      ref: this.ref,
      organization: this.organization ? this.organization.getId() : null,
    };
  }
}
